export enum ErrorTypeFDX {
    Warning = 'Warning',
    Error = 'Error'
}
